// src/schema/salesOrderSchema.js
// Shared schema for header, addresses, billTo, misc, udf, and items.
// Extend this if you add new fields in the form.

export const headerFieldsOLD = [
    { name: "soNumber", label: "SO Number" },
    { name: "owner", label: "Owner" },
    { name: "orderType", label: "Order Type" },
	{ name: "totalOrderedQuantity", label: "Total Ordered Qty", type: "number", readOnly: true },

    { name: "totalOrderLines", label: "Total Lines" },
    { name: "orderDate", label: "Order Date" },
    { name: "expectedReceiptDate", label: "Expected Receipt Date" },
    { name: "externalOrder1", label: "External Order #1" },
    { name: "Status", label: "Status" },
    { name: "createdBy", label: "Created By" },
    { name: "createdDate", label: "Created Date" },
    { name: "updatedBy", label: "Updated By" },
    { name: "updatedDate", label: "Updated Date" },
];


// headerFields with explicit i18n keys (labelKey). label kept for fallback.
export const headerFields = [
	{ name: "soNumber", label: "SO Number", labelKey: "salesOrder.table.soNumber" },
	{ name: "owner", label: "Owner", labelKey: "salesOrder.table.owner" },
	{ name: "orderType", label: "Order Type", labelKey: "salesOrder.table.orderType" },
	{ name: "totalOrderedQuantity", label: "Total Ordered Qty", type: "number", readOnly: true, labelKey: "salesOrder.table.totalOrderedQuantity" },

	{ name: "totalOrderLines", label: "Total Lines", labelKey: "salesOrder.table.totalOrderLines" },
	{ name: "orderDate", label: "Order Date", labelKey: "salesOrder.table.orderDate" },
	{ name: "expectedReceiptDate", label: "Expected Receipt Date", labelKey: "salesOrder.table.expectedReceiptDate" },
	{ name: "externalOrder1", label: "External Order #1", labelKey: "salesOrder.table.externalOrder1" },
	{ name: "status", label: "WMS Status", labelKey: "salesOrder.table.status" },
	{ name: "systemStatus", label: "System Status", labelKey: "salesOrder.table.systemStatus" },
	{ name: "erpStatus", label: "ERP Status", labelKey: "salesOrder.table.erpStatus" },
	{ name: "createdBy", label: "Created By", labelKey: "salesOrder.table.createdBy" },
	{ name: "createdDate", label: "Created Date", labelKey: "salesOrder.table.createdDate" },
	{ name: "updatedBy", label: "Updated By", labelKey: "salesOrder.table.updatedBy" },
	{ name: "updatedDate", label: "Updated Date", labelKey: "salesOrder.table.updatedDate" },
];


export const sourceAddressFieldsOLD = [
	{ name: "sourceLocationName", label: "Source Location Name", type: "text" },
	{ name: "sourceAddress1", label: "Source Address Line 1", type: "text" },
	{ name: "sourceAddress2", label: "Source Address Line 2", type: "text" },
	{ name: "sourceAddress3", label: "Source Address Line 3", type: "text" },
	{ name: "sourceAddress4", label: "Source Address Line 4", type: "text" },
	{ name: "sourceCity", label: "Source City", type: "text" },
	{ name: "sourceState", label: "Source State", type: "text" },
	{ name: "sourceCountry", label: "Source Country", type: "text" },
	{ name: "sourceContact", label: "Source Contact", type: "text" },
	{ name: "sourceEmail", label: "Source Email", type: "email" },
];


// SOURCE ADDRESS
export const sourceAddressFields = [
	{ name: "sourceLocationName", label: "Source Location Name", labelKey: "salesOrder.table.sourceLocationName" },
	{ name: "sourceAddress1", label: "Source Address Line 1", labelKey: "salesOrder.table.sourceAddress1" },
	{ name: "sourceAddress2", label: "Source Address Line 2", labelKey: "salesOrder.table.sourceAddress2" },
	{ name: "sourceAddress3", label: "Source Address Line 3", labelKey: "salesOrder.table.sourceAddress3" },
	{ name: "sourceAddress4", label: "Source Address Line 4", labelKey: "salesOrder.table.sourceAddress4" },
	{ name: "sourceCity", label: "Source City", labelKey: "salesOrder.table.sourceCity" },
	{ name: "sourceState", label: "Source State", labelKey: "salesOrder.table.sourceState" },
	{ name: "sourceCountry", label: "Source Country", labelKey: "salesOrder.table.sourceCountry" },
	{ name: "sourceContact", label: "Source Contact", labelKey: "salesOrder.table.sourceContact" },
	{ name: "sourceEmail", label: "Source Email", labelKey: "salesOrder.table.sourceEmail" },
];

export const destinationAddressFieldsOLD = [
	{ name: "destinationLocationName", label: "Destination Location Name", type: "text" },
	{ name: "destinationAddress1", label: "Destination Address Line 1", type: "text" },
	{ name: "destinationAddress2", label: "Destination Address Line 2", type: "text" },
	{ name: "destinationAddress3", label: "Destination Address Line 3", type: "text" },
	{ name: "destinationAddress4", label: "Destination Address Line 4", type: "text" },
	{ name: "destinationCity", label: "Destination City", type: "text" },
	{ name: "destinationState", label: "Destination State", type: "text" },
	{ name: "destinationCountry", label: "Destination Country", type: "text" },
	{ name: "destinationContact", label: "Destination Contact", type: "text" },
	{ name: "destinationEmail", label: "Destination Email", type: "email" },
];


// DESTINATION ADDRESS
export const destinationAddressFields = [
	{ name: "destinationName", label: "Destination Location Name", labelKey: "salesOrder.table.destinationLocationName" },
	{ name: "destinationAddress1", label: "Destination Address Line 1", labelKey: "salesOrder.table.destinationAddress1" },
	{ name: "destinationAddress2", label: "Destination Address Line 2", labelKey: "salesOrder.table.destinationAddress2" },
	{ name: "destinationAddress3", label: "Destination Address Line 3", labelKey: "salesOrder.table.destinationAddress3" },
	{ name: "destinationAddress4", label: "Destination Address Line 4", labelKey: "salesOrder.table.destinationAddress4" },
	{ name: "destinationCity", label: "Destination City", labelKey: "salesOrder.table.destinationCity" },
	{ name: "destinationState", label: "Destination State", labelKey: "salesOrder.table.destinationState" },
	{ name: "destinationCountry", label: "Destination Country", labelKey: "salesOrder.table.destinationCountry" },
	{ name: "destinationContact", label: "Destination Contact", labelKey: "salesOrder.table.destinationContact" },
	{ name: "destinationEmail", label: "Destination Email", labelKey: "salesOrder.table.destinationEmail" },
];

export const billToFieldsOLD = [
    { name: "billToName", label: "Bill To Name" },
    { name: "billToAddress1", label: "Bill To Address 1" },
    { name: "billToAddress2", label: "Bill To Address 2" },
    { name: "billToCity", label: "Bill To City" },
    { name: "billToState", label: "Bill To State" },
    { name: "billToCountry", label: "Bill To Country" },
    { name: "billToContact", label: "Bill To Contact" },
    { name: "billToEmail", label: "Bill To Email" },
];

// BILL TO FIELDS
export const billToFields = [
	{ name: "billToName", label: "Bill To Name", labelKey: "salesOrder.table.billToName" },
	{ name: "billToAddress1", label: "Bill To Address 1", labelKey: "salesOrder.table.billToAddress1" },
	{ name: "billToAddress2", label: "Bill To Address 2", labelKey: "salesOrder.table.billToAddress2" },
	{ name: "billToCity", label: "Bill To City", labelKey: "salesOrder.table.billToCity" },
	{ name: "billToState", label: "Bill To State", labelKey: "salesOrder.table.billToState" },
	{ name: "billToCountry", label: "Bill To Country", labelKey: "salesOrder.table.billToCountry" },
	{ name: "billToContact", label: "Bill To Contact", labelKey: "salesOrder.table.billToContact" },
	{ name: "billToEmail", label: "Bill To Email", labelKey: "salesOrder.table.billToEmail" },
];

export const miscFieldsOLD = [
    { name: "notes", label: "Notes" },
    { name: "termsOfDelivery", label: "Terms Of Delivery" },
    { name: "termsOfPayment", label: "Terms Of Payment" },
];


// MISC
export const miscFields = [
	{ name: "notes", label: "Notes", labelKey: "salesOrder.table.notes" },
	{ name: "termsOfDelivery", label: "Terms Of Delivery", labelKey: "salesOrder.table.termsOfDelivery" },
	{ name: "termsOfPayment", label: "Terms Of Payment", labelKey: "salesOrder.table.termsOfPayment" },
];

export const udfFieldsOLD = [
    { name: "soStoHeaderUdf1", label: "Header UDF 1" },
    { name: "soStoHeaderUdf2", label: "Header UDF 2" },
    { name: "soStoTextUdf1", label: "Text UDF 1" },
    { name: "soStoTextUdf2", label: "Text UDF 2" },
];

// UDF
export const udfFields = [
	{ name: "soStoHeaderUdf1", label: "Header UDF 1", labelKey: "salesOrder.table.soStoHeaderUdf1" },
	{ name: "soStoHeaderUdf2", label: "Header UDF 2", labelKey: "salesOrder.table.soStoHeaderUdf2" },
	{ name: "soStoTextUdf1", label: "Text UDF 1", labelKey: "salesOrder.table.soStoTextUdf1" },
	{ name: "soStoTextUdf2", label: "Text UDF 2", labelKey: "salesOrder.table.soStoTextUdf2" },
];



// item fields (used in SaveOrderTable / CreateSalesOrder)
export const itemFieldsOLD = [
    { name: "lineNumber", label: "Line#" },
    { name: "skuId", label: "SKU ID" },
    { name: "item", label: "Item (sku fallback)" },
    { name: "description", label: "Description" },
    { name: "pack", label: "Pack" },
    { name: "uom", label: "UOM" },
    { name: "orderQty", label: "Order Qty" },
    { name: "openQty", label: "Open Qty" },
	{name: "itemPOTolerance", label: "Tolerance %" },
    { name: "receivedQty", label: "Received Qty" },
    { name: "qcRequired", label: "QC Required" },
    { name: "status", label: "WMS Status" },
    { name: "itemweight", label: "Item Weight" },
    { name: "itemcode", label: "Item Volume" },
    // add more item-level fields you use
];


// ITEM FIELDS
export const itemFields = [
	{ name: "lineNumber", label: "Line#", labelKey: "salesOrder.table.lineNumber" },
	{ name: "skuId", label: "SKU ID", labelKey: "salesOrder.table.skuId" },
	{ name: "item", label: "Item", labelKey: "salesOrder.table.item" },
	{ name: "description", label: "Description", labelKey: "salesOrder.table.description" },
	{ name: "itemPerPrice", label: "Item per price", labelKey: "salesOrder.table.itemPerPrice" },
	{ name: "pack", label: "Pack", labelKey: "salesOrder.table.pack" },
	{ name: "uom", label: "UOM", labelKey: "salesOrder.table.uom" },
	{ name: "orderQty", label: "Order Qty", labelKey: "salesOrder.table.orderQty" },
	{ name: "openQty", label: "Open Qty", labelKey: "salesOrder.table.openQty" },
	{ name: "itemPOTolerance", label: "Tolerance %", labelKey: "salesOrder.table.itemPOTolerance" },
	{ name: "receivedQty", label: "Received Qty", labelKey: "salesOrder.table.receivedQty" },
	{ name: "qcRequired", label: "QC Required", labelKey: "salesOrder.table.qcRequired" },
	{ name: "status", label: "WMS Status", labelKey: "salesOrder.table.status" },
	{ name: "itemweight", label: "Item Weight", labelKey: "salesOrder.table.itemweight" },
	{ name: "itemcode", label: "Item Volume", labelKey: "salesOrder.table.itemcode" },
];

// ---------------- UI-Oriented Field Definitions (used by CreateSalesOrder) ----------------
// These mirror the inline arrays previously declared in CreateSalesOrder.jsx

export const formSections = [
	{
		title: "SO Header",
		fields: [
			{ name: "soNumber", label: "SO Number", type: "text", readOnly: true, hiddenOnCreate: true },
			{
				name: "orderType",
				label: "Order Type",
				type: "select",
				required: true,
				options: [
					{ value: "SO", label: "Sales Order" },
					{ value: "STO", label: "Stock Transfer Order" },
				],
			},
			{ name: "externalOrder", label: "External SO/STO#", type: "text", readOnly: true },
			{ name: "owner", label: "Owner", type: "partnerLookup", required: true },
			{ name: "expectedReceiptDate", label: "Expected Receipt Date", type: "date", required: true },
			{ name: "status", label: "WMS Status", type: "text", readOnly: true, defaultValue: "New"},
			{ name: "systemStatus", label: "System Status", type: "text", readOnly: true, defaultValue: "New"},
			{ name: "openQuantity", label: "Open Quantity", type: "number", readOnly: true },
			{ name: "totalWeight", label: "Total Weight", type: "number", readOnly: true },
			{ name: "totalVolume", label: "Total Volume", type: "number", readOnly: true },
			{ name: "totalOrderQuantity", label: "Total Order Quantity", type: "number", readOnly: true },
			{ name: "orderDate", label: "Order Date", type: "date", readOnly: true },
			{ name: "closeDate", label: "Close Date", type: "date", readOnly: true },
			{ name: "source", label: "Source", type: "text", readOnly: true },
			{ name: "loadId", label: "Load ID", type: "text" },
			{ name: "door", label: "Door", type: "text", readOnly: true },
			{ name: "route", label: "Route", type: "text", readOnly: true },
			{ name: "stop", label: "Stop", type: "text", readOnly: true },
		],
	},
	{
		title: "Address",
		fields: [{ name: "destinationName", label: "Destination Name", type: "text" }],
	},
	{
		title: "Carrier Data",
		fields: [
			{ name: "carrierCode", label: "Carrier Code", type: "text", disabledOnCreate: true },
			{ name: "carrierName", label: "Carrier Name", type: "text", disabledOnCreate: true },
			{ name: "carrierAddress1", label: "Carrier Address 1", type: "text", disabledOnCreate: true },
			{ name: "carrierAddress2", label: "Carrier Address 2", type: "text", disabledOnCreate: true },
			{ name: "carrierCity", label: "Carrier City", type: "text", disabledOnCreate: true },
			{ name: "carrierState", label: "Carrier State", type: "text", disabledOnCreate: true },
			{ name: "carrierCountry", label: "Carrier Country", type: "text", disabledOnCreate: true },
			{ name: "carrierPhone", label: "Carrier Phone", type: "text", disabledOnCreate: true },
			{ name: "carrierTrailerNumber", label: "Trailer Number", type: "text", disabledOnCreate: true },
			{ name: "carrierTrailerOwner", label: "Trailer Owner", type: "text", disabledOnCreate: true },
			{ name: "carrierDriverName", label: "Driver Name", type: "text", disabledOnCreate: true },
			{ name: "departureDateTime", label: "Departure Date Time", type: "datetime-local", disabledOnCreate: true },
			{ name: "actualDeliveryDate", label: "Actual Delivery Date", type: "date", disabledOnCreate: true },
		],
	},
	{
		title: "Bill To",
		hidden: true,
		fields: [
			{ name: "billToName", label: "Bill To Name", type: "text", required: true },
			{ name: "billToAddress1", label: "Address Line 1", type: "text", required: true },
			{ name: "billToAddress2", label: "Address Line 2", type: "text" },
			{ name: "billToAddress3", label: "Address Line 3", type: "text" },
			{ name: "billToAddress4", label: "Address Line 4", type: "text" },
			{ name: "billToCity", label: "City", type: "text", required: true },
			{ name: "billToState", label: "State", type: "text", required: true },
			{ name: "billToCountry", label: "Country", type: "text", required: true },
			{ name: "billToContact", label: "Contact", type: "text" },
			{ name: "billToEmail", label: "Email", type: "email" },
		],
	},
	{
		title: "Invoice",
		fields: [
			{ name: "invoiceNumber", label: "Invoice Number", type: "text" },
			{ name: "invoiceDate", label: "Invoice Date", type: "date" },
			{
				name: "invoiceType",
				label: "Invoice Type",
				type: "select",
				options: [
					{ value: "regular", label: "Regular" },
					{ value: "proforma", label: "Proforma" },
					{ value: "credit", label: "Credit Note" },
					{ value: "debit", label: "Debit Note" },
				],
			},
			{ name: "invoiceAmount", label: "Invoice Amount", type: "number" },
			{ name: "paymentTerms", label: "Payment Terms", type: "text" },
			{ name: "invoiceUpload", label: "Invoice Upload", type: "file" },
		],
	},
	{
		title: "Misc",
		fields: [
			{ name: "soHeaderUdf1", label: "SO Header UDF 1", type: "text" },
			{ name: "soHeaderUdf2", label: "SO Header UDF 2", type: "text" },
			{ name: "soHeaderUdf3", label: "SO Header UDF 3", type: "text" },
			{ name: "soHeaderUdf4", label: "SO Header UDF 4", type: "text" },
			{ name: "notes", label: "Notes",  },
			{ name: "termsOfDelivery", label: "Terms of Delivery", type: "text" },
			{ name: "termsOfPayment", label: "Terms of Payment", type: "text" },
			{ name: "createdBy", label: "Created By", type: "text", readOnly: true, autoFill: true },
			{ name: "createdDate", label: "Created Date", type: "date", readOnly: true, autoFill: true },
			{ name: "updatedBy", label: "Updated By", type: "text", readOnly: true, autoFill: true },
			{ name: "updatedDate", label: "Updated Date", type: "date", readOnly: true, autoFill: true },
		],
	},
	{
		title: "UDF",
		fields: [
			{ name: "soTextUdf1", label: "SO Text UDF 1", type: "text" },
			{ name: "soTextUdf2", label: "SO Text UDF 2", type: "text" },
			{ name: "soTextUdf3", label: "SO Text UDF 3", type: "text" },
			{ name: "soTextUdf4", label: "SO Text UDF 4", type: "text" },
		],
	},
];

export const sourceAddressFieldsSO = [
	{ name: "sourceLocationName", label: "Name", type: "customerLookup", required: true },
	{ name: "sourceAddress1", label: "Address Line 1", type: "text", required: true },
	{ name: "sourceAddress2", label: "Address Line 2", type: "text" },
	{ name: "sourceAddress3", label: "Address Line 3", type: "text" },
	{ name: "sourceAddress4", label: "Address Line 4", type: "text" },
	{ name: "sourceCity", label: "City", type: "text", required: true },
	{ name: "sourceState", label: "State", type: "text", required: true },
	{ name: "sourceCountry", label: "Country", type: "text", required: true },
	{ name: "sourceContact", label: "Contact", type: "text" },
	{ name: "sourceEmail", label: "Email", type: "email" },
];


export const destinationAddressFieldsSO = [
	{ name: "destinationName", label: "Name", type: "shipToLookup", required: true },
	{ name: "destinationAddress1", label: "Address Line 1", type: "text", required: true },
	{ name: "destinationAddress2", label: "Address Line 2", type: "text" },
	{ name: "destinationAddress3", label: "Address Line 3", type: "text" },
	{ name: "destinationAddress4", label: "Address Line 4", type: "text" },
	{ name: "destinationCity", label: "City", type: "text", required: true },
	{ name: "destinationState", label: "State", type: "text", required: true },
	{ name: "destinationCountry", label: "Country", type: "text", required: true },
	{ name: "destinationContact", label: "Contact", type: "text" },
	{ name: "destinationEmail", label: "Email", type: "email" },
];


export const addItemsFieldsDataOLD = [
	{ name: "lineNumber", label: "Line Number (Auto)", type: "text", readOnly: true },
	{ name: "item", label: "SKU ID", type: "text",  hasSearch: true, required: true },
	{ name: "description", label: "Description", type: "text", required: true },
	{ name: "itemcode", label: "Item Volume", type: "text" },
	{ name: "itemweight", label: "Item Weight", type: "number" },
	{ name: "pack", label: "Pack", type: "text", defaultValue: "STD" },
	{
		name: "uom",
		label: "UOM",
		type: "select",
		options: [
			{ value: "", label: "Select" },
			{ value: "EA", label: "EA" },
			{ value: "PCS", label: "PCS" },
			{ value: "KG", label: "KG" },
			{ value: "LBS", label: "LBS" },
			{ value: "M", label: "M" },
			{ value: "FT", label: "FT" },
		],
		required: true,
	},
	{ name: "orderQty", label: "Order Qty", type: "number", required: true },
	{ name: "itemPOTolerance", label: " Tolerance %", type: "number" },
	{ name: "qcRequired", label: "QC Required", type: "checkbox" },
	{ name: "openqty", label: "Open Qty", type: "text", readOnly: true },
	{ name: "receivedqty", label: "Received Qty", type: "text", readOnly: true },
	{ name: "status", label: "WMS Status", type: "text", defaultValue: "New", readOnly: true },
];

export const addItemsFieldsData = [
	{ name: "lineNumber", label: "Line Number (Auto)", type: "text", readOnly: true, labelKey: "salesOrder.table.lineNumberAuto" },

	{ name: "item", label: "SKU ID", type: "text", hasSearch: true, required: true, labelKey: "salesOrder.table.item" },

	{ name: "description", label: "Description", type: "text", required: true, labelKey: "salesOrder.table.description" },

	{
		name: "itemPerPrice",
		label: "Item per price",
		type: "number",
		readOnly: true,
		labelKey: "salesOrder.table.itemPerPrice",
	},

	{ name: "itemcode", label: "Item Volume", type: "text", labelKey: "salesOrder.table.itemcode" },

	{ name: "itemweight", label: "Item Weight", type: "number", labelKey: "salesOrder.table.itemweight" },

	{ name: "pack", label: "Pack", type: "text", defaultValue: "STD", labelKey: "salesOrder.table.pack" },

	{
		name: "uom",
		label: "UOM",
		type: "select",
		defaultValue: "EA",
		labelKey: "salesOrder.table.uom",
		options: [
			{ value: "", label: "Select" },
			{ value: "EA", label: "EA" },
			{ value: "PCS", label: "PCS" },
			{ value: "KG", label: "KG" },
			{ value: "LBS", label: "LBS" },
			{ value: "M", label: "M" },
			{ value: "FT", label: "FT" },
		],
		required: true,
	},

	{ name: "orderQty", label: "Order Qty", type: "number", required: true, labelKey: "salesOrder.table.orderQty" },

	{ name: "itemPOTolerance", label: "Tolerance %", type: "number", labelKey: "salesOrder.table.itemPOTolerance" },

	{ name: "qcRequired", label: "QC Required", type: "checkbox", labelKey: "salesOrder.table.qcRequired" },

	{ name: "openqty", label: "Open Qty", type: "text", readOnly: true, labelKey: "salesOrder.table.openQty" },

	{ name: "receivedqty", label: "Received Qty", type: "text", readOnly: true, labelKey: "salesOrder.table.receivedQty" },

	{ name: "status", label: "WMS Status", type: "text", defaultValue: "New", readOnly: true, labelKey: "salesOrder.table.status" },
];


// Convenience export: everything flattened so MainTable can easily build columns
// Prefer labels from header/address/billTo/misc/udf. Include only name/label.
export const ALL_FIELDS = [
	...headerFields,
	...sourceAddressFields,
	...destinationAddressFields,
	...billToFields,
	...miscFields,
	...udfFields,
	{ name: "source", label: "Source", width: 160 },
	// items are not part of the header table by default
];
